import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';

// Styles
// CoreUI Icons Set
import '@coreui/icons/css/coreui-icons.min.css';
// Import Flag Icons Set
import 'flag-icon-css/css/flag-icon.min.css';
// Import Font Awesome Icons Set
import 'font-awesome/css/font-awesome.min.css';
// Import Simple Line Icons Set
import 'simple-line-icons/css/simple-line-icons.css';

// Containers
import { DefaultLayout } from './containers';

// Auth
/*
* Custom withAuthenticator,
* use withAuthenticator from aws-amplify-react for default UI
*/
import { withAuthenticator } from 'aws-amplify-react-custom';
//import { withAuthenticator } from 'aws-amplify-react';
import AmplifyTheme from './Amplify-UI-Theme';

// Pages
import { Page404, Page500 } from './views/Pages';

// import { renderRoutes } from 'react-router-config';
const settings = require(`./settings/${process.env.REACT_APP_CUSTOMER || 'default'}.js`);
let logo = null;
if (process.env.REACT_APP_LOGO !== 'none') {
 logo = require(`./assets/${process.env.REACT_APP_CUSTOMER}/img/brand/${process.env.REACT_APP_LOGO}`);
}
require(`./scss/${process.env.REACT_APP_CUSTOMER}/${process.env.REACT_APP_USER_TYPE}/style.scss`);

const userType = process.env.REACT_APP_USER_TYPE;
let hideAuthComponents;
if (userType === 'admin'){
  hideAuthComponents = [{name:'SignUp'}];
}
else if (userType === 'caterer'){
  hideAuthComponents = [{name:'SignUp'}];
} 
else {
  hideAuthComponents = [];
}

const details = {
  userType: userType, 
  validEmailDomain: settings.allowedEmail || null,
  navbar: {
    img: logo,
    title: ''
  }
}

const Dashboard = withAuthenticator(DefaultLayout, false, [], null, AmplifyTheme, details, hideAuthComponents);
class App extends Component {
  render() {
    return (
      <Switch>
        <Route exact path="/404" name="Page 404" component={Page404} />
        <Route exact path="/500" name="Page 500" component={Page500} />
        <Route path="/" name="Home" render={props => <Dashboard {...props} />} />
      </Switch>
    );
  }
}

export default App;
